import RMTable from 'components/customComponents/Controls/RMTable';
import React, { useEffect, useState } from 'react';
import { IStyle } from 'Styles';
import { OrphanImagesResultDTO } from 'business/models/Models';
import PlateTypeService from 'business/services/PlateTypeService';
import { useOnConnectionStart } from './hooks';
import { useConnectHub, useHubConnection } from 'CustomHooks';
import { useDisconnectHub } from 'CustomHooks/useHubConnection';
import { FmlxButton, FmlxProgressBar } from 'fmlx-common-ui';

interface Props {
  results: OrphanImagesResultDTO[];
  setOrphanImagesResult: React.Dispatch<React.SetStateAction<OrphanImagesResultDTO[]>>;
}

const plateService = new PlateTypeService();

const OrphanImagesResults = (props: Props) => {
  const { results, setOrphanImagesResult } = props;
  const [selectedIndexes, setSelectedIndexes] = useState([0]);
  const [currentProgress, setCurrentProgress] = useState(0);
  const connection = useHubConnection();
  const disconnectHub = useDisconnectHub();
  const onConnectionStart = useOnConnectionStart();

  const orphanImagesResultHeaders: {
    accessor: string;
    Header: string;
    className?: string;
  }[] = [
    {
      accessor: 'path',
      Header: 'Image Store',
    },
    {
      accessor: 'plateId',
      Header: 'Plate Id',
    },
    {
      accessor: 'creationDate',
      Header: 'Creation Date',
    },
    {
      accessor: 'folderSize',
      Header: 'Folder Size (KB)',
    },
  ];

  const onTableRowCheckboxSelectionChange = (rowIndices: number[]) => {
    setSelectedIndexes([...rowIndices]);
  };

  const handleOnRowCLick = (row) => {
    setSelectedIndexes([row.index]);
  };

  const moveOrphanImagesToArchive = async () => {
    const selectedOrphanImages = results.filter((element, index) =>
      selectedIndexes.includes(index),
    );
    if (selectedOrphanImages?.length) {
      useConnectHub(connection, () =>
        onConnectionStart(
          connection,
          selectedOrphanImages[0].plateId,
          setCurrentProgress,
        ),
      );
      await plateService.moveOrphanImagesToArchive(selectedOrphanImages);
      const unArchivedOrphanImages = results.filter(
        (element, index) => !selectedIndexes.includes(index),
      );
      setOrphanImagesResult(unArchivedOrphanImages);
    } else {
      setCurrentProgress(0);
    }
  };

  useEffect(() => {
    return () => {
      disconnectHub(connection);
    };
  }, []);

  return (
    <>
      <RMTable
        columns={orphanImagesResultHeaders}
        data={results}
        tableClass="w-full"
        mainContainerStyle={styles.tableMainContainer}
        selectedIds={selectedIndexes}
        enableMultiSelection={true}
        onCheckboxSelectionChange={onTableRowCheckboxSelectionChange}
        onRowClicked={handleOnRowCLick}
      />
      <div
        id="orphanimagesresults-wrapper"
        className="flex flex-row justify-end mt-2 gap-2 align-items-center"
      >
        <div>Move Progress</div>
        <div className="flex-1">
          <FmlxProgressBar
            type={FmlxProgressBar.Type.LINEAR}
            value={currentProgress}
            size={FmlxProgressBar.Size.SMALL}
            showLabel
          />
        </div>
        <FmlxButton
          label={'MOVE TO ARCHIVE'}
          variant={FmlxButton.Variant.CONTAIN}
          type={FmlxButton.Type.BASIC}
          className={'whitespace-nowrap'}
          onClick={moveOrphanImagesToArchive}
        />
      </div>
    </>
  );
};

const styles: IStyle = {
  tableMainContainer: {
    width: '100%',
    height: '76vh',
    padding: '0.5%',
    border: '1px solid #E0E0E0',
  },
  progressBar: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    overflow: 'hidden',
    color: '#fff',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    backgroundColor: '#4CAF50',
    transition: 'width 1s ease',
  },
};

export default OrphanImagesResults;
